<div
  #mainContainer
  [attr.id]="id"
  [class]="'carousel d-flex flex-column ' + mainContainerClasses()"
  [ngStyle]="{ padding: carouselPadding() }"
>
  <div
    #itemsContainer
    class="items-container d-flex flex-row justify-center"
    [ngClass]="{ cards: mode() === 'CARD' }"
    (transitionstart)="handleAnimationRunning(true)"
    (transitionend)="handleAnimationRunning(false)"
    commonUtilitiesSwipeDetector
    [axisToLockOn]="'X'"
    [swipeThreshold]="swipeThreshold()"
    (swipeStart)="onSwipeStart($event)"
    (swiping)="swiping($event)"
    (isSwipingVertically)="handleSwipingVertically($event)"
    (singleTap)="handleSingleTap()"
    (swipedX)="onSwipeX()"
    (swipeEnd)="onSwipeEnd()"
  >
    <ng-content select="[commonUiCarouselSlide]"></ng-content>
  </div>
  <!-- Navigation -->
  @if (showNavigation()) {
    <div
      #navigationContainer
      [class]="'navigation-container p-medium d-flex flex-row radius-minus align-items-center ' + navigationContainerClasses()"
      [ngClass]="{
        'justify-content-space-between': showDots() && showNavigation() && !onlyOneNavigation(),
        'justify-content-center': onlyOneNavigation(),
      }"
    >
      <!-- Dots -->
      @if (showDots() && dots().length > 0) {
        <div
          [class]="'dots radius-big d-flex flex-row gap-tiny surface-back ' + navigationDotsContainerClasses()"
          [ngClass]="disableNavigationDots() ? 'surface-transparent' : 'p-low'"
        >
          @for (dot of dots(); track dot) {
            <div
              [ngClass]="{ active: dot === index() }"
              class="dot radius-giant"
            ></div>
          }
        </div>
      }
      <!-- End Dots -->

      <!-- Navigation Buttons -->
      @if (showButtons()) {
        <div class="buttons d-flex flex-row gap-medium">
          @if (index() !== 0) {
            <common-ui-components-temp-ngx-button
              [mode]="navigationButtonPrevText() !== '' ? 'section' : 'icon-only'"
              [style]="'tinted-on-elevated'"
              [size]="navigationButtonSize()"
              [leftIcon]="{ name: 'arrow-right', type: 'linear' }"
              (clickHandler)="handleNavigationBtnClick('PREV')"
            >
              {{ navigationButtonPrevText() }}
            </common-ui-components-temp-ngx-button>
          }

          <common-ui-components-temp-ngx-button
            [mode]="navigationButtonNextText() !== '' ? 'section' : 'icon-only'"
            [size]="navigationButtonSize()"
            [leftIcon]="{ name: 'arrow-left', type: 'linear' }"
            (clickHandler)="handleNavigationBtnClick('NEXT')"
          >
            {{ navigationButtonNextText() }}
          </common-ui-components-temp-ngx-button>
        </div>
      }
      <!-- End Navigation Buttons -->
    </div>
  }
  <!-- End Navigation -->
</div>
